// extracted by mini-css-extract-plugin
export default {"mn-exclusive-card":"index_mn-exclusive-card__FDD-0","collect":"index_collect__-Er2P"};